import { JobActionTypes, JobStatusTypes } from "@/common/enums";
import Helper from "@/common/helper.js"

export default class JobRunnerModel {    
    jobId: string | undefined;
    displayName: string | undefined;
    startTimestamp: number | undefined;
    endTimestamp: number | undefined;
    progress: number | undefined;
    jobStatus: JobStatusTypes | undefined;
    jobAction: JobActionTypes | undefined;
    statusDisplay: string | undefined;
    actionDisplay: string | undefined;
    startedBy: string | undefined;
    cancelledBy: string | undefined;
    canCancel: boolean | undefined;
    canDelete: boolean | undefined;
    isTimedOut: boolean | undefined;

    get startDisplay(): string {        
        if (this.startTimestamp == 0)
            return ""

        let local = Helper.convertUTCDateToLocalDate(new Date(this.startTimestamp!))        
        return local.toDateString().substring(4) + ", " + local.toLocaleTimeString()
    }

    get endDisplay(): string {        
        if (this.endTimestamp == 0)
            return ""
        let local = Helper.convertUTCDateToLocalDate(new Date(this.endTimestamp!))        
        return local.toDateString().substring(4) + ", " + local.toLocaleTimeString()
    }

    get isRunning(): boolean {        
        if (this.isTimedOut)
            return false
        
        return (
            this.jobStatus == JobStatusTypes.Launched ||
            this.jobStatus == JobStatusTypes.Started ||
            this.jobStatus == JobStatusTypes.Cancelling
        )

    }


    static from(json: string): JobRunnerModel {
        let model = Object.assign(new JobRunnerModel(), json);            

        return model;
    }
}